import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Cpu, MemoryStick, Timer, Database } from 'lucide-react';
import { serverStore } from '../../stores/server.store';
import { StatTile } from '../design/StatTile';
import { formatBytes, formatUptime } from '../../utils/overview-format';

/** Die vier Live-Kacheln der Server-Übersicht (Minecraft und Steam). */
export const ServerStatTiles = observer(({ diskSub }: { diskSub?: string }) => {
  const { activeServer } = serverStore;
  const [uptime, setUptime] = useState('—');

  useEffect(() => {
    if (activeServer?.status === 'online' && activeServer?.started_at) {
      setUptime(formatUptime(activeServer.started_at));
      const t = setInterval(() => setUptime(formatUptime(activeServer.started_at)), 1000);
      return () => clearInterval(t);
    }
    setUptime('—');
  }, [activeServer?.status, activeServer?.started_at]);

  if (!activeServer) return null;

  const online = activeServer.status === 'online';
  const cpu = Math.max(0, activeServer.cpu_usage || 0);
  const ram = Math.max(0, activeServer.ram_usage || 0);
  const ramPct = activeServer.ram_limit ? ram / activeServer.ram_limit : 0;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <StatTile
        label="CPU"
        icon={<Cpu size={14} />}
        value={`${cpu.toFixed(0)}%`}
        sub={online ? 'Live-Auslastung' : 'Server gestoppt'}
        fill={Math.min(1, cpu / 100)}
        accent={online ? 'ember' : 'muted'}
      />
      <StatTile
        label="RAM"
        icon={<MemoryStick size={14} />}
        value={`${ram.toFixed(1)} GB`}
        sub={`von ${activeServer.ram_limit} GB zugewiesen`}
        fill={ramPct}
        accent={ramPct > 0.9 ? 'warn' : online ? 'ember' : 'muted'}
      />
      <StatTile
        label="Laufzeit"
        icon={<Timer size={14} />}
        value={uptime}
        sub={online ? 'seit letztem Start' : 'gestoppt'}
        accent={online ? 'online' : 'muted'}
      />
      <StatTile
        label="Speicher"
        icon={<Database size={14} />}
        value={formatBytes(activeServer.disk_usage_bytes || 0)}
        sub={diskSub || 'Server-Daten auf Disk'}
        accent="muted"
      />
    </div>
  );
});
